/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tumor-board-outcome.reducer';

export const TumorBoardOutcomeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tumorBoardOutcomeEntity = useAppSelector(state => state.tumorBoardOutcome.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tumorBoardOutcomeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.tumorBoardOutcome.detail.title">TumorBoardOutcome</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOutcome.id">Id</Translate>
            </span>
          </dt>
          <dd>{tumorBoardOutcomeEntity.id}</dd>
          <dt>
            <span id="createdById">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOutcome.createdById">Created By Id</Translate>
            </span>
            <UncontrolledTooltip target="createdById">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOutcome.help.createdById" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardOutcomeEntity.createdById}</dd>
          <dt>
            <span id="createdByType">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOutcome.createdByType">Created By Type</Translate>
            </span>
          </dt>
          <dd>{tumorBoardOutcomeEntity.createdByType}</dd>
          <dt>
            <span id="outcomeSummary">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOutcome.outcomeSummary">Outcome Summary</Translate>
            </span>
            <UncontrolledTooltip target="outcomeSummary">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOutcome.help.outcomeSummary" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardOutcomeEntity.outcomeSummary}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOutcome.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOutcome.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardOutcomeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOutcome.cursor">Cursor</Translate>
            </span>
            <UncontrolledTooltip target="cursor">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOutcome.help.cursor" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardOutcomeEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOutcome.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOutcome.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardOutcomeEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOutcome.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOutcome.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardOutcomeEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOutcome.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOutcome.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardOutcomeEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumorBoardOutcome.patient">Patient</Translate>
          </dt>
          <dd>{tumorBoardOutcomeEntity.patient ? tumorBoardOutcomeEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumorBoardOutcome.occurrence">Occurrence</Translate>
          </dt>
          <dd>{tumorBoardOutcomeEntity.occurrence ? tumorBoardOutcomeEntity.occurrence.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/tumor-board-outcome" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/tumor-board-outcome/${tumorBoardOutcomeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TumorBoardOutcomeDetail;
